import React from 'react';

import { Tooltip, Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

const EmailFormatter = ({ email }) => {
    return (
        <Tooltip title={email}>
            <Typography
                noWrap
                sx={{
                    overflow: 'hidden',
                    textAlign: 'left',
                    textOverflow: 'ellipsis',
                    width: 'calc(100% - 16px)',
                }}
                variant="body2"
            >
                {email ? email : '- - -'}
            </Typography>
        </Tooltip>
    );
};

EmailFormatter.propTypes = {
    email: PropTypes.string,
};

export default EmailFormatter;
